import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withDirectives as _withDirectives, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "sidebar sidebar-theme sidebar-main sidebar-fixed sidebar-expand-md sidebar-subtracted" };
const _hoisted_2 = { class: "card card-sidebar-mobile" };
const _hoisted_3 = {
    key: 0,
    class: "sidebar-user company-select"
};
const _hoisted_4 = { class: "card-body" };
const _hoisted_5 = { class: "pb-2" };
const _hoisted_6 = {
    key: 0,
    class: "sub-sidebar--action-btn sidebar--action_btn--green"
};
const _hoisted_7 = {
    key: 1,
    class: "sub-sidebar--action-btn sidebar--action_btn--green"
};
const _hoisted_8 = {
    key: 2,
    class: "sub-sidebar--action-btn"
};
const _hoisted_9 = {
    key: 1,
    class: "mx-0 mt-0 mb-1"
};
const _hoisted_10 = {
    key: 2,
    class: "card-body p-0"
};
const _hoisted_11 = { class: "nav nav-sidebar" };
const _hoisted_12 = ["content"];
const _hoisted_13 = ["content"];
const _hoisted_14 = ["content"];
const _hoisted_15 = ["content"];
const _hoisted_16 = ["content"];
const _hoisted_17 = ["content"];
const _hoisted_18 = { class: "sub-sidebar--module-icon" };
const _hoisted_19 = ["content"];
const _hoisted_20 = { class: "sub-sidebar--module-icon" };
const _hoisted_21 = ["content"];
const _hoisted_22 = { class: "sub-sidebar--module-icon" };
const _hoisted_23 = ["content"];
const _hoisted_24 = { class: "sub-sidebar--module-icon" };
const _hoisted_25 = ["content"];
const _hoisted_26 = { class: "sub-sidebar--module-icon" };
const _hoisted_27 = ["content"];
const _hoisted_28 = { class: "sub-sidebar--module-icon" };
const _hoisted_29 = ["content"];
const _hoisted_30 = { class: "sub-sidebar--module-icon" };
const _hoisted_31 = ["content"];
const _hoisted_32 = { class: "sub-sidebar--module-icon" };
const _hoisted_33 = ["content"];
const _hoisted_34 = { class: "sub-sidebar--module-icon" };
const _hoisted_35 = ["content"];
const _hoisted_36 = { class: "sub-sidebar--module-icon" };
const _hoisted_37 = ["content"];
const _hoisted_38 = { class: "sub-sidebar--module-list-icon" };
import ProjectsIcon from '@/components/icons/projects.vue';
import ClientsIcon from '@/components/icons/clients.vue';
import InvoiceIcon from '@/components/icons/invoice.vue';
import GraphIcon from '@/components/icons/graph.vue';
import CompanyIcon from '@/components/icons/company.vue';
import BoxIcon from '@/components/icons/box.vue';
import { restrictTrial as vRestrictTrial } from '@/directives';
import { useAuthStore } from '@/stores/auth.ts';
import { computed } from 'vue';
import { authService } from '@/models/auth';
import { moduleService } from '@/models/module-service.ts';
import CreateIcon from '@/components/icons/create.vue';
import DatabaseIcon from '@/components/icons/database.vue';
import { useSubscriptionStore } from '@/stores/subscription.js';
import { subscriptionTypesMap } from '@/data/type-maps.js';
import CommercialSuggestion from '@/components/icons/modules/commercial-suggestion.vue';
import ExpensesLogo from '@/components/icons/modules/expenses-logo.vue';
import IndividualActivity from '@/components/icons/modules/individual-activity.vue';
import WaybillLogo from '@/components/icons/modules/waybill-logo.vue';
import CompanyContractsLogo from '@/components/icons/modules/company-contracts-logo.vue';
import ReportsLogo from '@/components/icons/modules/reports-logo.vue';
import PeriodicInvoice from '@/components/icons/modules/periodic-invoice.vue';
import WarehouseLogo from '@/components/icons/modules/warehouse-logo.vue';
import PuzzleIcon from '@/components/icons/puzzle.vue';
import WorkActLogo from '@/components/icons/modules/work-act-logo.vue';
import AutomaticPaymentLogo from '@/components/icons/modules/automatic-payment-logo.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'sub-sidebar',
    setup(__props) {
        const authStore = useAuthStore();
        const subscriptionStore = useSubscriptionStore();
        const showWaybills = computed(() => Boolean(authService.can('waybill.index') && (moduleService.can('waybill'))));
        const showCompanyContracts = computed(() => Boolean(authService.can('company-contracts.index') && (moduleService.can('company-contract'))));
        const showPlanMessage = computed(() => { var _a, _b; return ((_b = (_a = authStore.user) === null || _a === void 0 ? void 0 : _a.permissions) === null || _b === void 0 ? void 0 : _b.subscription.tag) === 'free' && (!authStore.user.activeCompany || authStore.user.activeCompany.owner); });
        const showSubscriptionExtend = computed(() => { var _a; return authStore.expirationDays !== null && authStore.expirationDays < 10 && ((_a = authStore.company) === null || _a === void 0 ? void 0 : _a.owner) && !authStore.user.permissions.user_subscription.subscription_recurring; });
        const canSeeCreateInvoice = computed(() => { var _a, _b; return authStore.company && ((_b = (_a = authStore.user) === null || _a === void 0 ? void 0 : _a.permissions) === null || _b === void 0 ? void 0 : _b.subscription.tag) !== subscriptionTypesMap.free && !authStore.isAdmin && authService.can('invoice.create'); });
        const showPeriodicInvoices = computed(() => Boolean(authService.can('invoice.index') && authService.canSub('recurring_invoice') && moduleService.can('periodic-invoice')));
        const showWarehouse = computed(() => Boolean(moduleService.can('warehouse')) && Boolean(authService.can('warehouse.index')));
        function openPaymentModal() {
            subscriptionStore.setModalVisible(true);
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _directive_tippy = _resolveDirective("tippy");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(["sidebar-content", { 'sidebar-content-trial': _unref(authStore).showAnyBar }])
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        (_unref(authStore).company || _unref(authStore).otherCompanies.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createVNode(_component_router_link, { to: { name: 'company.edit', params: { tab: 'info' } } }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_4, [
                                            _createVNode(CompanyIcon, { class: "text-black" })
                                        ])
                                    ]),
                                    _: 1
                                })
                            ]))
                            : _createCommentVNode("", true),
                        _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "m-0" }, null, -1)),
                        _createElementVNode("div", _hoisted_5, [
                            (showPlanMessage.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createElementVNode("button", {
                                        onClick: openPaymentModal,
                                        class: "btn w-100"
                                    }, [
                                        _createVNode(DatabaseIcon)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (showSubscriptionExtend.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createElementVNode("button", {
                                        onClick: openPaymentModal,
                                        class: "btn w-100"
                                    }, [
                                        _createVNode(DatabaseIcon)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (canSeeCreateInvoice.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createVNode(_component_router_link, {
                                        to: { name: 'invoice.create' },
                                        class: "btn btn-primary w-100"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(CreateIcon)
                                        ]),
                                        _: 1
                                    })
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        (showPlanMessage.value || showSubscriptionExtend.value || canSeeCreateInvoice.value)
                            ? (_openBlock(), _createElementBlock("hr", _hoisted_9))
                            : _createCommentVNode("", true),
                        (_unref(authStore).company)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    (_ctx.$auth.can('dashboard'))
                                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "sub-sidebar--tab sub-sidebar--tab--main",
                                            content: _ctx.$t('dashboard.statistics.stats')
                                        }, [
                                            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                                                to: { name: 'dashboard' },
                                                exact: "",
                                                class: "sub-sidebar--item"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(GraphIcon)
                                                ]),
                                                _: 1
                                            })), [
                                                [_unref(vRestrictTrial)]
                                            ])
                                        ], 8, _hoisted_12)), [
                                            [_directive_tippy, { placement: 'right', arrow: true }]
                                        ])
                                        : _createCommentVNode("", true),
                                    (_ctx.$auth.can('invoice.index'))
                                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            class: "sub-sidebar--tab sub-sidebar--tab--main",
                                            content: _ctx.$t('sidebar.invoices')
                                        }, [
                                            _createElementVNode("div", null, [
                                                _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                                                    type: "button",
                                                    to: { name: 'invoice.index' },
                                                    class: "sub-sidebar--item"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(InvoiceIcon)
                                                    ]),
                                                    _: 1
                                                })), [
                                                    [_unref(vRestrictTrial)]
                                                ])
                                            ])
                                        ], 8, _hoisted_13)), [
                                            [_directive_tippy, { placement: 'right', arrow: true }]
                                        ])
                                        : _createCommentVNode("", true),
                                    (_ctx.$auth.can('client.index'))
                                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: 2,
                                            class: "sub-sidebar--tab sub-sidebar--tab--main",
                                            content: _ctx.$t('client.index.title')
                                        }, [
                                            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                                                to: { name: 'client.index' },
                                                class: "sub-sidebar--item"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(ClientsIcon)
                                                ]),
                                                _: 1
                                            })), [
                                                [_unref(vRestrictTrial)]
                                            ])
                                        ], 8, _hoisted_14)), [
                                            [_directive_tippy, { placement: 'right', arrow: true }]
                                        ])
                                        : _createCommentVNode("", true),
                                    (_ctx.$auth.can('product.index'))
                                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: 3,
                                            class: "sub-sidebar--tab sub-sidebar--tab--main",
                                            content: _ctx.$t('product.index.title')
                                        }, [
                                            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                                                to: { name: 'product.index' },
                                                class: "sub-sidebar--item"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(BoxIcon)
                                                ]),
                                                _: 1
                                            })), [
                                                [_unref(vRestrictTrial)]
                                            ])
                                        ], 8, _hoisted_15)), [
                                            [_directive_tippy, { placement: 'right', arrow: true }]
                                        ])
                                        : _createCommentVNode("", true),
                                    (_ctx.$auth.can('project.index'))
                                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: 4,
                                            class: "sub-sidebar--tab sub-sidebar--tab--main",
                                            content: _ctx.$t('project.index.title')
                                        }, [
                                            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                                                to: { name: 'project.index' },
                                                class: "sub-sidebar--item"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(ProjectsIcon)
                                                ]),
                                                _: 1
                                            })), [
                                                [_unref(vRestrictTrial)]
                                            ])
                                        ], 8, _hoisted_16)), [
                                            [_directive_tippy, { placement: 'right', arrow: true }]
                                        ])
                                        : _createCommentVNode("", true),
                                    _cache[0] || (_cache[0] = _createElementVNode("hr", {
                                        class: "mx-0 mt-2",
                                        style: { "margin-bottom": "2px" }
                                    }, null, -1)),
                                    (showPeriodicInvoices.value)
                                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: 5,
                                            class: "sub-sidebar--tab sub-sidebar--tab--module",
                                            content: _ctx.$t('periodic_invoice.index.title')
                                        }, [
                                            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                                                to: { name: 'periodic-invoice.index' },
                                                class: "sub-sidebar--item"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_18, [
                                                        _createVNode(PeriodicInvoice)
                                                    ])
                                                ]),
                                                _: 1
                                            })), [
                                                [_unref(vRestrictTrial)]
                                            ])
                                        ], 8, _hoisted_17)), [
                                            [_directive_tippy, { placement: 'right', arrow: true }]
                                        ])
                                        : _createCommentVNode("", true),
                                    (_ctx.$module.can('work_act') && _ctx.$auth.can('work_act.index'))
                                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: 6,
                                            class: "sub-sidebar--tab sub-sidebar--tab--module",
                                            content: _ctx.$t('work-act.index.acts')
                                        }, [
                                            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                                                to: { name: 'work-act.index' },
                                                class: "sub-sidebar--item"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_20, [
                                                        _createVNode(WorkActLogo)
                                                    ])
                                                ]),
                                                _: 1
                                            })), [
                                                [_unref(vRestrictTrial)]
                                            ])
                                        ], 8, _hoisted_19)), [
                                            [_directive_tippy, { placement: 'right', arrow: true }]
                                        ])
                                        : _createCommentVNode("", true),
                                    (_ctx.$module.can('sip') && _unref(authStore).company.show_bank_statements && _ctx.$auth.can('sip.index'))
                                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: 7,
                                            class: "sub-sidebar--tab sub-sidebar--tab--module",
                                            content: _ctx.$t('sip.index.payments_statement')
                                        }, [
                                            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                                                to: { name: 'sip-statements.payments.index' },
                                                class: "sub-sidebar--item"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_22, [
                                                        _createVNode(AutomaticPaymentLogo)
                                                    ])
                                                ]),
                                                _: 1
                                            })), [
                                                [_unref(vRestrictTrial)]
                                            ])
                                        ], 8, _hoisted_21)), [
                                            [_directive_tippy, { placement: 'right', arrow: true }]
                                        ])
                                        : _createCommentVNode("", true),
                                    (_ctx.$module.can('commercial-suggestion') && _ctx.$auth.can('commercial-suggestion.index'))
                                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: 8,
                                            class: "sub-sidebar--tab sub-sidebar--tab--module",
                                            content: _ctx.$t('commercial-suggestion.index.title')
                                        }, [
                                            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                                                to: { name: 'commercial-suggestion.index' },
                                                class: "sub-sidebar--item"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_24, [
                                                        _createVNode(CommercialSuggestion)
                                                    ])
                                                ]),
                                                _: 1
                                            })), [
                                                [_unref(vRestrictTrial)]
                                            ])
                                        ], 8, _hoisted_23)), [
                                            [_directive_tippy, { placement: 'right', arrow: true }]
                                        ])
                                        : _createCommentVNode("", true),
                                    (_ctx.$module.can('expenses') && _ctx.$auth.can('expense.index'))
                                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: 9,
                                            class: "sub-sidebar--tab sub-sidebar--tab--module",
                                            content: _ctx.$t('expense.index.title')
                                        }, [
                                            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                                                to: { name: 'expense.index' },
                                                class: "sub-sidebar--item"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_26, [
                                                        _createVNode(ExpensesLogo)
                                                    ])
                                                ]),
                                                _: 1
                                            })), [
                                                [_unref(vRestrictTrial)]
                                            ])
                                        ], 8, _hoisted_25)), [
                                            [_directive_tippy, { placement: 'right', arrow: true }]
                                        ])
                                        : _createCommentVNode("", true),
                                    (showWarehouse.value)
                                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: 10,
                                            class: "sub-sidebar--tab sub-sidebar--tab--module",
                                            content: _ctx.$t('warehouse.index.title')
                                        }, [
                                            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                                                to: { name: 'warehouse.index' },
                                                class: "sub-sidebar--item"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_28, [
                                                        _createVNode(WarehouseLogo)
                                                    ])
                                                ]),
                                                _: 1
                                            })), [
                                                [_unref(vRestrictTrial)]
                                            ])
                                        ], 8, _hoisted_27)), [
                                            [_directive_tippy, { placement: 'right', arrow: true }]
                                        ])
                                        : _createCommentVNode("", true),
                                    (_ctx.$module.can('iv') && _unref(authStore).company && _ctx.$auth.can('journal.index') && _unref(authStore).company.show_journal)
                                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: 11,
                                            class: "sub-sidebar--tab sub-sidebar--tab--module",
                                            content: _ctx.$t('journal.index.title')
                                        }, [
                                            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                                                to: { name: 'journal.index' },
                                                class: "sub-sidebar--item"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_30, [
                                                        _createVNode(IndividualActivity)
                                                    ])
                                                ]),
                                                _: 1
                                            })), [
                                                [_unref(vRestrictTrial)]
                                            ])
                                        ], 8, _hoisted_29)), [
                                            [_directive_tippy, { placement: 'right', arrow: true }]
                                        ])
                                        : _createCommentVNode("", true),
                                    (showWaybills.value)
                                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: 12,
                                            class: "sub-sidebar--tab sub-sidebar--tab--module",
                                            content: _ctx.$t('waybill.index.title')
                                        }, [
                                            _createElementVNode("div", null, [
                                                _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                                                    to: { name: 'waybill.index' },
                                                    class: "sub-sidebar--item"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_32, [
                                                            _createVNode(WaybillLogo, { class: "waybill-logo" })
                                                        ])
                                                    ]),
                                                    _: 1
                                                })), [
                                                    [_unref(vRestrictTrial)]
                                                ])
                                            ])
                                        ], 8, _hoisted_31)), [
                                            [_directive_tippy, { placement: 'right', arrow: true }]
                                        ])
                                        : _createCommentVNode("", true),
                                    (showCompanyContracts.value)
                                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: 13,
                                            class: "sub-sidebar--tab sub-sidebar--tab--module",
                                            content: _ctx.$t('company-contract.index.title')
                                        }, [
                                            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                                                to: { name: 'company-contracts.index' },
                                                class: "sub-sidebar--item"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_34, [
                                                        _createVNode(CompanyContractsLogo)
                                                    ])
                                                ]),
                                                _: 1
                                            })), [
                                                [_unref(vRestrictTrial)]
                                            ])
                                        ], 8, _hoisted_33)), [
                                            [_directive_tippy, { placement: 'right', arrow: true }]
                                        ])
                                        : _createCommentVNode("", true),
                                    (_ctx.$module.can('reports') && _ctx.$auth.can('reports.index'))
                                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: 14,
                                            class: "sub-sidebar--tab sub-sidebar--tab--module",
                                            content: _ctx.$t('reports.index.title')
                                        }, [
                                            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                                                to: { name: 'reports.index' },
                                                class: "sub-sidebar--item"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_36, [
                                                        _createVNode(ReportsLogo)
                                                    ])
                                                ]),
                                                _: 1
                                            })), [
                                                [_unref(vRestrictTrial)]
                                            ])
                                        ], 8, _hoisted_35)), [
                                            [_directive_tippy, { placement: 'right', arrow: true }]
                                        ])
                                        : _createCommentVNode("", true),
                                    _withDirectives((_openBlock(), _createElementBlock("div", {
                                        class: "sub-sidebar--tab sub-sidebar--tab--module-list",
                                        content: _ctx.$t('module.links.all_modules')
                                    }, [
                                        _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                                            to: { name: 'module.index' },
                                            class: "sub-sidebar--item"
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_38, [
                                                    _createVNode(PuzzleIcon)
                                                ])
                                            ]),
                                            _: 1
                                        })), [
                                            [_unref(vRestrictTrial)]
                                        ])
                                    ], 8, _hoisted_37)), [
                                        [_directive_tippy, { placement: 'right', arrow: true }]
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ], 2)
            ]));
        };
    }
});
